module.exports = __webpack_public_path__ + "c4b3b434970538521e7f1403051d2c18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-uplanner.svg
// module id = 1182
// module chunks = 0